<template>
  <div :style="{ background: event.branding.tertiaryColor }">
    <h1>ADMIN</h1>
  </div>
</template>
<script>
/**
 * Admin Overlay for additional Functionalies
 * NOT YET IN USE
 */
export default {
  name: "AdminOverlay",
  components: {},
  data() {},
};
</script>
